import {find, filter} from 'lodash'
import moment from 'moment'
import convertNumber from '@/mixin/convertNumber'
import serviceCategoriesList from '@/mixin/serviceCategoriesList'

export default {
  mixins: [convertNumber, serviceCategoriesList],
  methods: {
    setColorServiceName (serviceName, paymentDate, potentialColumn) {
      const diff = moment().diff(paymentDate, 'month')
      const red = diff >= 3 && potentialColumn
      const yellow = diff >= 2 && diff < 3 && potentialColumn
      let status
      if (red) {
        status = 'red'
      } else if (yellow) {
        status = 'yellow'
      }
      return `<span class="bb-table-kpi-services bb-table-kpi-services_${status}">${serviceName}</span>`
    },
    getServiceType (id) {
      const serviceType = find(this.serviceCategoriesList, {id: id})
      return serviceType ? serviceType.name : ''
    },
    serviceAmount ({serviceValue, serviceQuantity = 1, serviceDiscount = 0}) {
      const value = serviceValue * serviceQuantity
      const discount = (serviceDiscount * value) / 100
      return value - discount
    },
    getPotentialValue (service, extra, serviceApprovedValue) {
      const serviceAmount = this.serviceAmount(service)
      const serviceValue = serviceAmount - serviceApprovedValue
      return extra ? service.serviceExtraValue : serviceValue
    },
    getIdEmployee (userTypeBC, service, extra) {
      const idBM = extra ? service.extraBusinessConsultant : service.businessConsultant
      const idPM = extra ? service.serviceExtraProjectManager : service.serviceProjectManager
      return userTypeBC ? idBM : idPM
    },
    getApprovedDate (userTypeBC, service, extra) {
      const dateApprovedExtraPC = service.serviceApprovedExtraDate
      const dateApprovedRealPC = service.serviceApprovedDate
      const dateApprovedExtraBM = service.serviceApprovedExtraDateBusinessConsultant
      const dateApprovedRealBM = service.serviceApprovedDateBusinessConsultant
      const dateApprovedPC = extra ? dateApprovedExtraPC : dateApprovedRealPC
      const dateApprovedBM = extra ? dateApprovedExtraBM : dateApprovedRealBM
      return userTypeBC ? dateApprovedBM : dateApprovedPC
    },
    getNameService (userTypeBC, service, extra) {
      const serviceType = this.getServiceType(service.serviceCategory)
      const serviceNameWithCategory = serviceType + ' re. ' + service.serviceName
      const serviceNameBC = serviceNameWithCategory
      const serviceNamePM = extra ? serviceNameWithCategory : service.serviceName
      const serviceName = userTypeBC ? serviceNameBC : serviceNamePM
      return serviceName
    },
    getApprovedValue (userTypeBC, item, extra) {
      const approvedValuePMExtra = item.serviceExtraApprovedValue
      const approvedValuePMReal = item.serviceApprovedValue
      const approvedValueBCExtra = item.servicesApprovedExtraValueBusinessConsultant
      const approvedValueBCReal = item.serviceApprovedValueBusinessConsultant
      const approvedValuePM = extra ? approvedValuePMExtra : approvedValuePMReal
      const approvedValueBC = extra ? approvedValueBCExtra : approvedValueBCReal
      const serviceApprovedValue = userTypeBC ? approvedValueBC : approvedValuePM
      return serviceApprovedValue
    },
    getAmount (transferRecipient, justAmount, service) {
      if (transferRecipient && service.serviceIsBonusKpi) {
        const classes = 'bb-table-body__item__approved-icon_double bb-table-body__item__approved-icon_double_amount'
        const icon = `<span class="${classes}">x2</span>`
        return icon + this.convertNumber(justAmount * 2)
      } else {
        return transferRecipient ? justAmount : service.transfers
      }
    },
    setServicesPM (data, column, userID, userType, funds) {
      const potentialColumn = column === 'potential'
      const userTypeBC = userType === 1
      const services = filter(data, item => {
        const extra = item.serviceCategory === 1
        const serviceApprovedValue = this.getApprovedValue(userTypeBC, item, extra)
        const serviceAmount = extra ? item.serviceExtraValue : this.serviceAmount(item)
        const potentialFilter = serviceAmount !== serviceApprovedValue
        const earnedFilter = serviceApprovedValue > 0
        return potentialColumn ? potentialFilter : earnedFilter
      })
      services.forEach(service => {
        // set name
        const extra = service.serviceCategory === 1
        const serviceName = this.getNameService(userTypeBC, service, extra)
        service.name = service.clientNickName + ' - ' + serviceName
        service.nameHtml = this.setColorServiceName(serviceName, service.paymentDate, potentialColumn)
        // set value
        const serviceApprovedValue = this.getApprovedValue(userTypeBC, service, extra)
        const currentValue = extra ? service.serviceCurrentExtraValue : service.serviceCurrentValue
        const transfersValue = extra ? 0 : (service.transfers || 0)
        const potentialAmount = currentValue - serviceApprovedValue
        const earnedAmount = serviceApprovedValue + transfersValue
        const idEmployee = this.getIdEmployee(userTypeBC, service, extra)
        const transferRecipient = userID === idEmployee || funds
        const justAmount = potentialColumn ? potentialAmount : earnedAmount
        service.amount = this.getAmount(transferRecipient, justAmount, service)
        // set date
        const approvedDate = this.getApprovedDate(userTypeBC, service, extra)
        service.approvedDate = approvedDate || ''
        // cases
        const potential = this.getPotentialValue(service, extra, serviceApprovedValue)
        // not paid
        if (!service.paymentDate) {
          service.paymentDate = '<i class="bb-table-body__item_gray">Not paid</i>'
          service.amount = potential
          service.static = true
        }
        // no amount for approve
        const noFullApproved = potentialAmount <= 0
        const noAmountToApprove = serviceApprovedValue === 0 && potentialAmount <= 0
        const extraNoAmount = extra && service.serviceCurrentExtraValue <= 0
        if ((extraNoAmount || noAmountToApprove || noFullApproved) && potentialColumn) {
          service.amount = potential
          service.static = true
        }
      })
      return services
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/setKpiServices.js